import { makeClassName } from '@siteless/util';

let StarIcon = ({ className }: { className?: string }) => (
  <span className={className}>★</span>
);

export let StarRating = ({
  rating = 0,
  maxStars = 5,
  className,
  starClassName = 'text-rose-bright',
  emptyStarClassName = 'text-neutral-200',
  hideEmptyStars = false,
}: {
  rating: number;
  maxStars?: number;
  className?: string;
  starClassName?: string;
  emptyStarClassName?: string;
  hideEmptyStars?: boolean;
}) => {
  const safeRating = Math.max(0, Math.min(rating, maxStars));

  const filledStars = Math.floor(safeRating);
  const hasHalfStar =
    safeRating - filledStars >= 0.25 && safeRating - filledStars <= 0.75;

  return (
    <div className={makeClassName('flex items-center', className)}>
      {[...Array(maxStars)].map((_, index) => {
        if (index < filledStars) {
          return <StarIcon key={index} className={starClassName} />;
        } else if (index === filledStars && hasHalfStar) {
          return (
            <span key={index} className={starClassName}>
              ½
            </span>
          );
        } else {
          return hideEmptyStars ? null : (
            <StarIcon key={index} className={emptyStarClassName} />
          );
        }
      })}
    </div>
  );
};
